import { isNumber } from 'lodash-es'

window.personForm = {}

window.personForm.filterPersoon = (data) => {

    while (data.postcode.match(/[-]/)) {
        data.postcode = data.postcode.replace(/[-]/, '')
    }

    while (data.postcode.match(/[\s]/)) {
        data.postcode = data.postcode.replace(/[\s]/, '')
    }

    while (data.telefoonVast.match(/[-]/)) {
        data.telefoonVast = data.telefoonVast.replace(/[-]/, '')
    }

    while (data.telefoonVast.match(/[\s]/)) {
        data.telefoonVast = data.telefoonVast.replace(/[\s]/, '')
    }

    data.telefoonVast = data.telefoonVast.replace('+310', '+31')

    while (data.telefoonMobiel.match(/[-]/)) {
        data.telefoonMobiel = data.telefoonMobiel.replace(/[-]/, '')
    }

    while (data.telefoonMobiel.match(/[\s]/)) {
        data.telefoonMobiel = data.telefoonMobiel.replace(/[\s]/, '')
    }

    data.telefoonMobiel = data.telefoonMobiel.replace('+310', '+31')

    while (data.telefoonVastExtra.match(/[-]/)) {
        data.telefoonVastExtra = data.telefoonVastExtra.replace(/[-]/, '')
    }

    while (data.telefoonVastExtra.match(/[\s]/)) {
        data.telefoonVastExtra = data.telefoonVastExtra.replace(/[\s]/, '')
    }

    data.telefoonVastExtra = data.telefoonVastExtra.replace('+310', '+31')

    while (data.telefoonMobielExtra.match(/[-]/)) {
        data.telefoonMobielExtra = data.telefoonMobielExtra.replace(/[-]/, '')
    }

    while (data.telefoonMobielExtra.match(/[\s]/)) {
        data.telefoonMobielExtra = data.telefoonMobielExtra.replace(/[\s]/, '')
    }

    data.telefoonMobielExtra = data.telefoonMobielExtra.replace('+310', '+31')

    while (data.emailAdres.match(/[\s]/)) {
        data.emailAdres = data.emailAdres.replace(/[\s]/, '')
    }

    data.emailAdres = data.emailAdres.toLowerCase()

    while (data.burgerServiceNummer.match(/[.]/)) {
        data.burgerServiceNummer = data.burgerServiceNummer.replace(/[.]/, '')
    }

    while (data.burgerServiceNummer.match(/[\s]/)) {
        data.burgerServiceNummer = data.burgerServiceNummer.replace(/[\s]/, '')
    }

    while (data.iban.match(/[.]/)) {
        data.iban = data.iban.replace(/[.]/, '')
    }

    while (data.iban.match(/[\s]/)) {
        data.iban = data.iban.replace(/[\s]/, '')
    }

    data.iban = data.iban.toUpperCase()

    while (data.bic.match(/[.]/)) {
        data.bic = data.bic.replace(/[.]/, '')
    }

    while (data.bic.match(/[\s]/)) {
        data.bic = data.bic.replace(/[\s]/, '')
    }

    data.bic = data.bic.toUpperCase()

    if (data.hasOwnProperty('vrijveld51')) {
        data.vrijveld51 = data.vrijveld51.replace(',', '.')
    }
    if (data.hasOwnProperty('vrijveld52')) {
        data.vrijveld52 = data.vrijveld52.replace(',', '.')
    }
    if (data.hasOwnProperty('vrijveld53')) {
        data.vrijveld53 = data.vrijveld53.replace(',', '.')
    }
    if (data.hasOwnProperty('vrijveld54')) {
        data.vrijveld54 = data.vrijveld54.replace(',', '.')
    }
    if (data.hasOwnProperty('vrijveld55')) {
        data.vrijveld55 = data.vrijveld55.replace(',', '.')
    }

    return data
}

window.personForm.validatePersoon = (data, asHTMLList = false) => {

    const errors = []

    const addError = (selector, message) => {
        errors.push({
            selector,
            message,
        })
    }

    if (data.roepnaam == '' && data.voorletters == '') {
        addError('roepnaam', 'De roepnaam of de voorletters zijn niet ingevoerd.')
        addError('voorletters', 'De roepnaam of de voorletters zijn niet ingevoerd.')
    }

    if (data.achternaam == '') {
        addError('achternaam', 'De achternaam is niet ingevoerd.')
    }

    if (data.geslacht < 1) {
        addError('geslacht', 'Het geslacht is niet geselecteerd.')
    }

    if (data.geboortedatum != '') {

        if (!data.geboortedatum.match(/^((0[1-9]|[12][0-9]|3[01])[-.](0[1-9]|1[012])[-.](19|20)[0-9]{2})$/)) {

            addError('geboortedatum', 'De geboortedatum is niet in het correcte formaat (dd-mm-jjjj).')

        } else {

            const day = parseInt(data.geboortedatum.substring(0, 2), 10)
            const month = parseInt(data.geboortedatum.substring(3, 5), 10)
            const year = parseInt(data.geboortedatum.substring(6, 10))

            if (day < 1 || day > 31) {
                addError('geboortedatum', 'De geboortedag is ongeldig.')
            } else if (month < 1 || month > 12) {
                addError('geboortedatum', 'De geboortemaand is ongeldig.')
            } else if ((month == 4 || month == 6 || month == 9 || month == 11) && day > 30) {
                addError('geboortedatum', 'De geboortedag is ongeldig.')
            } else if (month == 2 && day > 29) {
                addError('geboortedatum', 'De geboortedag is ongeldig.')
            } else if (month == 2 && (year % 400) != 0 && ((year % 4) != 0 || (year % 100) == 0) && day > 28) {
                addError('geboortedatum', 'De geboortedag is ongeldig.')
            } else if (year < 1902) {
                addError('geboortedatum', 'Het geboortejaar mag niet eerder zijn dan 1902.')
            } else if (year > 2036) {
                addError('geboortedatum', 'Het geboortejaar mag niet later zijn dan 2036.')
            }

            const today = new Date()
            today.setMonth(today.getMonth() + 9)

            if (year > today.getFullYear()) {
                addError('geboortedatum', 'De geboortedatum kan niet later zijn dan 9 maanden na vandaag.')
            } else if (year == today.getFullYear() && month > today.getMonth() + 1) {
                addError('geboortedatum', 'De geboortedatum kan niet later zijn dan 9 maanden na vandaag.')
            } else if (year == today.getFullYear() && month == today.getMonth() + 1 && day > today.getDate()) {
                addError('geboortedatum', 'De geboortedatum kan niet later zijn dan 9 maanden na vandaag.')
            }
        }
    }

    if (!data.hasOwnProperty('adrID') || data.adrID > 0 || data.straat != '' || data.nummer != '' || data.postcode != '' || data.plaats != '' || data.adres != '') {

        if (data.land == 13) {

            if (data.straat == '' || data.nummer == '' || data.postcode == '' || data.plaats == '') {
                addError('postcode', 'Het adres is niet of onvolledig ingevoerd.')
                addError('nummer', 'Het adres is niet of onvolledig ingevoerd.')
            }

        } else {

            if (data.adres == '') {
                addError('adres', 'Het adres is niet ingevoerd.')
            }
        }
    }

    if (data.postcode != '') {

        if (!data.postcode.match(/^[1-9][0-9]{3}[A-Za-z]{2}$/i)) {
            addError('postcode', 'De ingevoerde postcode is ongeldig.')
        }
    }

    if (data.telefoonVast != '') {

        if (!validateTelefoonVast(data.telefoonVast)) {
            addError('telefoonVast', 'Het ingevoerde vaste telefoonnummer is ongeldig.')
        }
    }

    if (data.telefoonMobiel != '') {

        if (!validateTelefoonMobiel(data.telefoonMobiel)) {
            addError('telefoonMobiel', 'Het ingevoerde mobiele telefoonnummer is ongeldig.')
        }
    }

    if (data.telefoonVastExtra != '') {

        if (!validateTelefoonVast(data.telefoonVastExtra)) {
            addError('telefoonVastExtra', 'Het ingevoerde extra vaste telefoonnummer is ongeldig.')
        }
    }

    if (data.telefoonMobielExtra != '') {

        if (!validateTelefoonMobiel(data.telefoonMobielExtra)) {
            addError('telefoonMobielExtra', 'Het ingevoerde extra mobiele telefoonnummer is ongeldig.')
        }
    }

    if (data.emailAdres != '') {

        if (!validateEmailadres(data.emailAdres)) {
            addError('emailAdres', 'Het ingevoerde e-mailadres is ongeldig.')
        }
    }

    if (data.burgerServiceNummer != '' && !data.burgerServiceNummer.match(/[*]/)) {

        if (data.burgerServiceNummer != parseInt(data.burgerServiceNummer)) {
            addError('burgerServiceNummer', 'Het ingevoerde burger service nummer is ongeldig.')
        } else if (data.burgerServiceNummer.length < 8 || data.burgerServiceNummer.length > 9) {
            addError('burgerServiceNummer', 'Het ingevoerde burger service nummer is ongeldig.')
        } else if (data.burgerServiceNummer.length == 8 || data.burgerServiceNummer.length == 9) {
            const length = data.burgerServiceNummer.length
            let sum = 0
            for (let i = 0; i < length; i++) {
                let mul = (length - i)
                if (mul == 1){
                    mul = -1
                }
                sum += mul * parseInt(data.burgerServiceNummer.substr(i, 1))
            }
            if (sum % 11 != 0) {
                addError('burgerServiceNummer', 'Het ingevoerde burger service nummer is ongeldig.')
            }
        }
    }

    if (data.iban != '' && !data.iban.match(/[*]/)) {

        if (!validateIBAN(data.iban)) {
            addError('iban', 'De ingevoerde IBAN is ongeldig.')
        }
    }

    if (data.bic != '') {

        if (data.iban == '') {
            addError('iban', 'De IBAN is niet ingevoerd.')
        }
        if (data.bic.length != 8 && data.bic.length != 11) {
            addError('bic', 'De ingevoerde BIC is ongeldig.')
        }
    }

    if (data.klantnummer1Nr != '' && data.klantnummer1 < 1) {
        addError('klantnummer1Nr', 'Het klantnummer 1 is niet ingevoerd.')
    }

    if (data.klantnummer2Nr != '' && data.klantnummer2 < 1) {
        addError('klantnummer2Nr', 'Het klantnummer 2 is niet ingevoerd.')
    }

    if (data.hasOwnProperty('vrijveld51') && data.vrijveld51 != '' && !isNumber(data.vrijveld51)) {
        addError('vrijveld51', document.querySelector('#vrijveld51-label > label').textContent + ' is ongeldig.')
    }
    if (data.hasOwnProperty('vrijveld52') && data.vrijveld52 != '' && !isNumber(data.vrijveld52)) {
        addError('vrijveld52', document.querySelector('#vrijveld52-label > label').textContent + ' is ongeldig.')
    }
    if (data.hasOwnProperty('vrijveld53') && data.vrijveld53 != '' && !isNumber(data.vrijveld53)) {
        addError('vrijveld53', document.querySelector('#vrijveld53-label > label').textContent + ' is ongeldig.')
    }
    if (data.hasOwnProperty('vrijveld54') && data.vrijveld54 != '' && !isNumber(data.vrijveld54)) {
        addError('vrijveld54', document.querySelector('#vrijveld54-label > label').textContent + ' is ongeldig.')
    }
    if (data.hasOwnProperty('vrijveld55') && data.vrijveld55 != '' && !isNumber(data.vrijveld55)) {
        addError('vrijveld55', document.querySelector('#vrijveld55-label > label').textContent + ' is ongeldig.')
    }

    if (data.hasOwnProperty('verwerkingPersoonsgegevens')) {
        if (data.verwerkingPersoonsgegevens == '') {
            addError('verwerkingPersoonsgegevens', 'Toestemming verwerking persoonsgegevens is niet geselecteerd.')
        }
    }

    if (data.hasOwnProperty('mailingsAlgemeen')) {
        if (data.mailingsAlgemeen == '') {
            addError('mailingsAlgemeen', 'Ontvangen van algemene mailings is niet geselecteerd.')
        }
    }

    if (data.hasOwnProperty('mailingsNieuwsbrieven')) {
        if (data.mailingsNieuwsbrieven == '') {
            addError('mailingsNieuwsbrieven', 'Ontvangen van nieuwsbrieven is niet geselecteerd.')
        }
    }

    if (data.hasOwnProperty('mailingsReclame')) {
        if (data.mailingsReclame == '') {
            addError('mailingsReclame', 'Ontvangen van reclame is niet geselecteerd.')
        }
    }

    if (asHTMLList) {
        if (!errors.length) {
            return ''
        }
        const uniqueErrors = [...new Set(errors.map((error) => error.message))]
        return uniqueErrors.reduce((acc, cur) => {
            acc += '<li>' + cur + '</li>'
            return acc
        },'<ul>') + '</ul>'
    }

    return errors
}
